import classAPI from '../queries/class';
import router from '../../../../router';

export const complete = ({ _ }, classId) => classAPI.complete(classId);

export const sendToNextClass = ({ rootState }) => {
  const classId = rootState.classIndex.activePost.id;
  classAPI.getNext(classId).then((response) => {
    const { data } = response;
    const nextPost = data.next_post;

    if (!nextPost) {
      router.push({
        name: 'index',
      });
    }

    router.push({
      name: 'class',
      params: {
        slug: nextPost.slug,
      },
    });
  });
};

export const sendToPreviousClass = ({ rootState }) => {
  const classId = rootState.classIndex.activePost.id;
  classAPI.getPrevious(classId).then((response) => {
    const { data } = response;
    const previousPost = data.previous_post;

    if (!previousPost) {
      router.push({
        name: 'index',
      });
    }

    router.push({
      name: 'class',
      params: {
        slug: previousPost.slug,
      },
    });
  });
};



// WEBPACK FOOTER //
// ./src/screens/Class/Progress/store/actions.js